module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/collab/collab-scroll-03-6b73edcc2d293b2f392e762c7b4b5a9e.jpg";